import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WaitlistBanner from "@/components/WaitlistBanner";
import Services from "@/components/Services";
import About from "@/components/About";
import WhyUs from "@/components/WhyUs";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const HomePage = () => {
  return (
    <main data-testid="home-page" className="min-h-screen">
      <Navbar />
      <Hero />
      <WaitlistBanner />
      <Services />
      <About />
      <WhyUs />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
};

export default HomePage;
